<template>
  <div :class="item.classes">
    <p
      v-for="(line, index) in item.lines"
      :key="index"
      :class="line.classes"
      v-html="line.html"
    ></p>
  </div>
</template>

<script>
export default {
  name: 'NodeText',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>
